import { render, staticRenderFns } from "./pun.vue?vue&type=template&id=cb2f4520&"
import script from "./pun.vue?vue&type=script&lang=js&"
export * from "./pun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports